import { IHealthProblemCoSoItemRequest } from "../../../models/request/y-te/yTeRequests";
import { healthproblem, HealthProblemCoSoItemResponse } from "../../../models/response/y-te/healthproblem";
import {
	eHealthProblemActionTypeIds,
	IHealthProblemChangeDangKyDatas,
	IHealthProblemChangeSelectedIds,
	IHealthProblemCloseConfirm,
	IHealthProblemCloseDangKyModal,
	IHealthProblemCloseDetail,
	IHealthProblemDeleteErr,
	IHealthProblemDeleteStart,
	IHealthProblemDeleteSuccess,
	IHealthProblemLoadDangKyErr,
	IHealthProblemLoadDangKyStart,
	IHealthProblemLoadDangKySuccess,
	IHealthProblemLoadDetailErr,
	IHealthProblemLoadDetailStart,
	IHealthProblemLoadDetailSuccess,
	IHealthProblemLoadErr,
	IHealthProblemLoadStart,
	IHealthProblemLoadSuccess,
	IHealthProblemSaveDangKyErr,
	IHealthProblemSaveDangKyStart,
	IHealthProblemSaveDangKySuccess,
	IHealthProblemSaveErr,
	IHealthProblemSaveStart,
	IHealthProblemSaveSuccess,
	IHealthProblemShowConfirm,
	IHealthProblemShowDangKyModal,
	IHealthProblemShowDetail
} from "../../action-types/y-te/IHealthProblemActionTypes";

export const healthProblemActions = {
	loadHealthProblemStart: (dm_coso_id: number): IHealthProblemLoadStart => {
		return {
			type: eHealthProblemActionTypeIds.LOAD_START,
			payload: dm_coso_id
		}
	},
	loadHealthProblemSuccess: (data: HealthProblemCoSoItemResponse[]): IHealthProblemLoadSuccess => {
		return {
			type: eHealthProblemActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadHealthProblemError: (message: string): IHealthProblemLoadErr => {
		return {
			type: eHealthProblemActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadHealthProblemDetailStart: (id: number): IHealthProblemLoadDetailStart => {
		return {
			type: eHealthProblemActionTypeIds.LOAD_DETAIL_START,
			payload: id
		}
	},
	loadHealthProblemDetailSuccess: (data: healthproblem): IHealthProblemLoadDetailSuccess => {
		return {
			type: eHealthProblemActionTypeIds.LOAD_DETAIL_SUCCESS,
			payload: data
		}
	},
	loadHealthProblemDetailError: (message: string): IHealthProblemLoadDetailErr => {
		return {
			type: eHealthProblemActionTypeIds.LOAD_DETAIL_ERROR,
			payload: message
		}
	},
	showHealthProblemDetail: (data?: healthproblem): IHealthProblemShowDetail => {
		return {
			type: eHealthProblemActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeHealthProblemDetail: (): IHealthProblemCloseDetail => {
		return {
			type: eHealthProblemActionTypeIds.CLOSE_DETAIL
		}
	},
	changeHealthProblemSelectedIds: (ids: number[]): IHealthProblemChangeSelectedIds => {
		return {
			type: eHealthProblemActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	showHealthProblemConfirm: (): IHealthProblemShowConfirm => {
		return {
			type: eHealthProblemActionTypeIds.SHOW_CONFIRM
		}
	},
	closeHealthProblemConfirm: (): IHealthProblemCloseConfirm => {
		return {
			type: eHealthProblemActionTypeIds.CLOSE_CONFIRM
		}
	},
	saveHealthProblemStart: (data: healthproblem): IHealthProblemSaveStart => {
		return {
			type: eHealthProblemActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveHealthProblemSuccess: (is_update: boolean): IHealthProblemSaveSuccess => {
		return {
			type: eHealthProblemActionTypeIds.SAVE_SUCCESS,
			payload: is_update
		}
	},
	saveHealthProblemError: (message: string): IHealthProblemSaveErr => {
		return {
			type: eHealthProblemActionTypeIds.SAVE_ERROR,
			payload: message
		}
	},
	deleteHealthProblemStart: (id: number): IHealthProblemDeleteStart => {
		return {
			type: eHealthProblemActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteHealthProblemSuccess: (): IHealthProblemDeleteSuccess => {
		return {
			type: eHealthProblemActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteHealthProblemError: (message: string): IHealthProblemDeleteErr => {
		return {
			type: eHealthProblemActionTypeIds.DELETE_ERROR,
			payload: message
		}
	},
	showHealthProblemDangKyModal: (): IHealthProblemShowDangKyModal => {
		return {
			type: eHealthProblemActionTypeIds.SHOW_DANGKY_MODAL
		}
	},
	closeHealthProblemDangKyModal: (): IHealthProblemCloseDangKyModal => {
		return {
			type: eHealthProblemActionTypeIds.CLOSE_DANGKY_MODAL
		}
	},
	loadHealthProblemDangKyStart: (dm_coso_id: number): IHealthProblemLoadDangKyStart => {
		return {
			type: eHealthProblemActionTypeIds.LOAD_DANGKY_START,
			payload: dm_coso_id
		}
	},
	loadHealthProblemDangKySuccess: (data: HealthProblemCoSoItemResponse[]): IHealthProblemLoadDangKySuccess => {
		return {
			type: eHealthProblemActionTypeIds.LOAD_DANGKY_SUCCESS,
			payload: data
		}
	},
	loadHealthProblemDangKyError: (message: string): IHealthProblemLoadDangKyErr => {
		return {
			type: eHealthProblemActionTypeIds.LOAD_DANGKY_ERROR,
			payload: message
		}
	},
	changeHealthProblemDangKyDatas: (data: HealthProblemCoSoItemResponse[]): IHealthProblemChangeDangKyDatas => {
		return {
			type: eHealthProblemActionTypeIds.CHANGE_DANGKY_DATAS,
			payload: data
		}
	},
	saveHealthProblemDangKyStart: (request: IHealthProblemCoSoItemRequest): IHealthProblemSaveDangKyStart => {
		return {
			type: eHealthProblemActionTypeIds.SAVE_DANGKY_START,
			payload: request
		}
	},
	saveHealthProblemDangKySuccess: (): IHealthProblemSaveDangKySuccess => {
		return {
			type: eHealthProblemActionTypeIds.SAVE_DANGKY_SUCCESS
		}
	},
	saveHealthProblemDangKyError: (message: string): IHealthProblemSaveDangKyErr => {
		return {
			type: eHealthProblemActionTypeIds.SAVE_DANGKY_ERROR,
			payload: message
		}
	}
}
